import { graphql } from "../../gql";

export const startMutation = graphql(`
    mutation AppTaskAiAssistStart($baseVariantId: ID!) {
        taskAiAssistThreadStart(baseVariantId: $baseVariantId) {
            error
            taskAiAssistThread {
                id
                aiThreadItems {
                    ...AiAssistModal_AiThreadItem
                }
            }
        }
    }
`);

export const continueMutation = graphql(`
    mutation AppTaskAiAssistContinue($threadId: ID!, $input: String!) {
        taskAiAssistThreadContinue(threadId: $threadId, input: $input) {
            error
            taskAiAssistThread {
                id
                aiThreadItems {
                    ...AiAssistModal_AiThreadItem
                }
            }
        }
    }
`);
